import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";

const SectionBlock = ({ heading, children }) => (
  <div className="mb-7 last:mb-0">
    <h4 className="font-condensed uppercase tracking-widest text-[12px] md:text-[13px] text-lime mb-3">
      {heading}
    </h4>
    {children}
  </div>
);

const BulletList = ({ items }) => (
  <ul className="space-y-2">
    {items.map((it, i) => (
      <li
        key={i}
        className="flex items-start gap-3 text-[15px] md:text-[1rem] leading-relaxed opacity-90"
      >
        <span
          className="mt-[10px] flex-shrink-0 w-1.5 h-1.5 bg-lime"
          aria-hidden="true"
        />
        <span>{it}</span>
      </li>
    ))}
  </ul>
);

const JobCard = ({ job, onApply, testId }) => {
  const [open, setOpen] = useState(false);
  const { title, category, location, chi, ruolo, responsabilita, mansioni, richiediamo, plus } = job;

  return (
    <div className="border-t border-dodgers/20 last:border-b" data-testid={testId}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full text-left py-7 md:py-9 grid grid-cols-12 gap-4 items-center group"
        aria-expanded={open}
        data-hover="true"
      >
        <div className="col-span-12 md:col-span-7">
          <h3 className="font-display text-xl md:text-3xl leading-tight group-hover:text-mandrogni transition-colors">
            {title}
          </h3>
        </div>
        <div className="col-span-8 md:col-span-3 text-sm md:text-[15px] opacity-75 font-condensed uppercase tracking-widest">
          {category} · {location}
        </div>
        <div className="col-span-4 md:col-span-2 flex justify-end">
          <span className="w-10 h-10 inline-flex items-center justify-center border border-dodgers">
            {open ? <Minus size={18} /> : <Plus size={18} />}
          </span>
        </div>
      </button>

      {open && (
        <div className="pb-12 pr-4 md:pr-16 grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-10">
            {chi && (
              <SectionBlock heading="Chi cerchiamo">
                <p className="text-[15px] md:text-[1.0625rem] leading-relaxed opacity-90 max-w-[72ch]">
                  {chi}
                </p>
              </SectionBlock>
            )}
            {ruolo && (
              <SectionBlock heading="Il ruolo">
                <p className="text-[15px] md:text-[1.0625rem] leading-relaxed opacity-90 max-w-[72ch]">
                  {ruolo}
                </p>
              </SectionBlock>
            )}
            {responsabilita?.length > 0 && (
              <SectionBlock heading="Responsabilità">
                <BulletList items={responsabilita} />
              </SectionBlock>
            )}
            {mansioni?.length > 0 && (
              <SectionBlock heading="Mansioni principali">
                <BulletList items={mansioni} />
              </SectionBlock>
            )}
            {richiediamo?.length > 0 && (
              <SectionBlock heading="Cosa chiediamo">
                <BulletList items={richiediamo} />
              </SectionBlock>
            )}
            {plus?.length > 0 && (
              <SectionBlock heading="Completano il profilo">
                <BulletList items={plus} />
              </SectionBlock>
            )}

            <div className="mt-8">
              <button
                type="button"
                className="btn-os btn-secondary-dark"
                onClick={() => onApply && onApply(title)}
                data-testid={`apply-${title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
              >
                <span>Candidati</span>
                <span className="arrow" aria-hidden="true">→</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default JobCard;
